import {Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { UnitOfWork, StateMap} from '../../services/common';
import { UtilFns, LocationFns } from '../../utils/common';
import { PageState,  ColumnSorter } from '../../controls/common';
import { PaginationService, IPaginationInstance} from '../../controls/ng2-pagination/ng2-pagination';

import { ROUTES } from '../routes';
import { Synonym } from '../../entities/Synonym';

import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { DxDataGridComponent } from 'devextreme-angular';

class PageStateExt extends PageState {
    searchTerm: string;
    operatorName: string;
}

@Component({
    templateUrl: './search-synonyms.html',
    providers: [PaginationService]
})
export class SearchSynonymsComponent implements OnInit, AfterViewInit {
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

    _synonyms: Synonym[];

    _operators = [
        { name: 'startsWith', title: 'StartingWith' },
        { name: 'contains', title: 'Containing' }
    ];

    _pagination: IPaginationInstance;
    _colSorter: ColumnSorter;

    _pageSize = 50;
    _pageState = new PageStateExt('Synonyms');

    _componentInitializing = true;
    _pageStatusMessage: string;
    _totalItemCount = 0;

    dataSource: DataSource;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap,
        public _location: Location, public _router: Router ) {
    }

    ngOnInit() {

        this._pageState.operatorName = this._operators[0].name;

        this.defineGridCustomDataStore();
    }

    ngAfterViewInit() {
        if (this.dataGrid) {
            this.dataGrid.visible = false;
        }
    }

    opChange(event: any) {
        // avoid thrashing
        const opName = event.target.value;
        if (this._pageState.operatorName == opName) { return; }
        this._pageState.operatorName = opName;
    }

    newSearch() {
        this._pageStatusMessage = '';
        this._pageStatusMessage = '';

        this.dataGrid.visible = true;
        this.dataGrid.instance.pageIndex(0);

        this._pageState.resetPaging();

        this.getSynonymSearchTotalCount(this._pageState.searchTerm, this._pageState.operatorName).then(() => {
            this.dataGrid.instance.refresh();
        });
    }

    public getSynonymSearchTotalCount(synonym: string, opType: string): Promise<any> {

        const params = { synonym: synonym, opType: opType};
        return this._uow.fetch('Materials/FetchSynonymSearchCount', params).then( c => {
            if (c != null && c.length > 0) {
                this._totalItemCount = c[0];
            } else {
                this._totalItemCount = 0;
            }
        });
    }

    clear() {
        this._pageState.searchTerm = '';
        this._pageState.resetPaging();
        this._pageStatusMessage = '';

        if (this.dataGrid.visible) {
            this._componentInitializing = true;
            this.dataGrid.instance.pageIndex(0);
            this.dataGrid.instance.refresh();
            this.dataGrid.visible = false;
        }
    }

    defineGridCustomDataStore() {
        this.dataSource = new DataSource({
            store: new CustomStore({
                load: (loadOptions: any) => {
                    if (this._componentInitializing) {
                        this._pageState.isLoading = false;
                        this._pageState.itemCount = 0;
                        this._pageState.isLoadedWithNoData = true;
                        this._componentInitializing = false;
                        return Promise.resolve({data: [], totalCount: 0});
                    }

                    let sort = {name: 'synonymWord', isDesc: false};
                    if (loadOptions.sort) {
                        sort = {
                            name: loadOptions.sort[0].selector,
                            isDesc: !!loadOptions.sort[0].desc
                        };
                    }

                    const skip = loadOptions.skip ? loadOptions.skip / loadOptions.take : 0;

                    this._pageState.isLoading = true;

                    const opValue = {} as any;
                    const searchTerm = this._pageState.searchTerm.replace(/\&/g, '%26');
                    opValue[this._pageState.operatorName] = searchTerm;
                    const pred = {'synonymWord': opValue};
                    const orderBy = 'synonymWord';

                    this._pageState.isLoading = true;
                    return this._uow.synonymRepository.wherePaged(pred, orderBy, skip + 1, this._pageSize)
                        .then( r => {
                            if (r != null && r.length > 0) {
                                this._pageState.itemCount = r.length;
                                this._pageStatusMessage = this._totalItemCount + ' matching Synonyms found.';
                            } else {
                                this._pageState.itemCount = 0;
                                this._pageState.isLoadedWithNoData = true;
                                this._pageStatusMessage = 'No matching Synonyms found that match your search criteria';
                                this.dataGrid.visible = false;
                            }
                            this._pageState.isLoading = false;
                            return {
                                data: r,
                                totalCount: this._totalItemCount
                            };
                        });
                }
            })
        });
    }

    onSelectMaterial(evt: any) {
        const s = <Synonym> evt.selectedRowsData[0];

        this._router.navigate(UtilFns.asRouterParts(ROUTES.Material, s.materialId ));

        return false;
    }

    hasStatusMessage(): boolean {
        return this.isValidString(this._pageStatusMessage);
    }

    isValidString(teststring: string) {
        if (!teststring) { return false; }

        return (teststring.trim().length > 0);
    }
}
